// Import bootstrap and dependencies
import 'jquery';
import 'popper.js';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';

import React from 'react';
import ReactDOM from 'react-dom';
import Raven from 'raven-js'

import './index.css';
import registerServiceWorker from './registerServiceWorker';
import {Router} from './Router';

Raven.config(process.env.REACT_APP_SENTRY_DSN).install()

ReactDOM.render(
  <Router />,
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js